<template>
  <b-form-group
    label="Bitiş Tarihi"
    label-for="edate"
  >
    <validation-provider
      #default="{ errors }"
      name="Bitiş Tarihi"
      rules="required"
    >
      <b-form-datepicker
        v-model="itemData.edate"
        v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'EDateNotificationCard',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['notifications/dataItem']
    },
  },
}
</script>
